import { useState } from 'react';
import { useHistory } from 'react-router';
import { apiCheckMember } from '../../Api/Login/Login';
import {
  TemplateFirstLoginStep1, TemplateResetPasswordMailStep2
} from '../../Templates';

const FirstLogin = () => {
  const history = useHistory();
  const [state, setState] = useState({
    step: 1,
    mail: '',
    isValid: true,
    msgError: '',
    shouldShowForgotLink: false,
    firstConnexion: true
  });

  const onChange = (value) => {
    setState(prevState => ({
      ...prevState,
      mail: value
    }));
  };

  const onReturn = () => {
    history.push('/login');
  };

  const nextStep = async () => {
    try {
      const res = await apiCheckMember(state.mail);
      if (res.status === 200) {
        setState(prevState => ({ ...prevState, step: prevState.step + 1 }));
      } else if (res.status >= 400 && res.errors.length > 0) {
        setState(prevState => ({
          ...prevState,
          isValid: false,
          shouldShowForgotLink: res.status == 404,
          msgError: (
            
              <span className="error-msg">{res.errors[0]}</span>
            
          )
        }));
      } else {
        setState(prevState => ({
          ...prevState,
          isValid: true,
          msgError: '',
          shouldShowForgotLink: false
        }));
      }
    } catch (err) {
      console.error('Error checking member:', err);
      setState(prevState => ({
        ...prevState,
        isValid: false,
        msgError: <span className="error-msg">An error occurred. Please try again.</span>,
        shouldShowForgotLink: false
      }));
    }
  };

  const componentProps = { onChange, onReturn, nextStep };

  switch (state.step) {
    case 1:
      return <TemplateFirstLoginStep1 {...state} {...componentProps} />;

    case 2:
      return <TemplateResetPasswordMailStep2 {...state} {...componentProps} />;

    default:
      return null;
  }
};

export default FirstLogin;
